import SeoPage from "../components/SeoPage";

export default function WebDevelopment() {
  return (
    <SeoPage
      title="Web Development Company in India | Arviko"
      description="Arviko Technology offers modern web development services using React, Node.js, and MERN stack."
      heading="Web Development Company in India"
    >
      <p>
        Arviko Technology is a leading web development company providing scalable and high-performance web applications.
      </p>
      <p>
        We specialize in React, Node.js, and MERN stack development to build modern digital products.
      </p>
    </SeoPage>
  );
}